
<template>
  <div class="aaa">
    <InfoHead />
    <div class="esignTest" v-if="!changecolor">
      <div class="design-set">
        <vue-esign

          class="esign"
          ref="esign"
          :width="1000"
          :height="600"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
      </div>
    </div>
    <div class="imgs">
      <img :src="img" alt />
    </div>

    <div class="foot">
      <div class="information-bottom" @click="handleReset">reset</div>
      <div class="information-bottom1" :class="{ 'changecolor': changecolor }" v-on:click="handleGenerate">Submit</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import InfoHead from "../components/InfoHead.vue";
export default {
  components: {
    InfoHead
  },
  data() {
    return {
      changecolor:false,
      updateInfo2: true,
      updateInfo: false,
      lineWidth: 6,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      isCrop: false,
      info: {
        agreement: "",
        autograph: "",
        uid: 0
      },
      img: ""
    };
  },
  mounted() {
    axios
      .get(
        `/agreement/agreement/selectAutograph?uid=${+sessionStorage.getItem(
          "token"
        )}`
      )
      .then(res => {
        ////console.log(res);
        try {
          if (res.data.data.length != 0) {
            if (res.data.data[0].autograph != ""&&res.data.data[0].autograph != null) {
              this.img = res.data.data[0].autograph;
              this.changecolor=true
            } else {
              this.updateInfo = true;
            }
          } else {
            this.updateInfo = true;
          }
        } catch {}
      });
  },

  methods: {
    //清空
    handleReset() {
      this.$refs.esign.reset();
    },

    //转换图片
    handleGenerate() {
      if (this.updateInfo) {
        this.$refs.esign
          .generate()
          .then(res => {
            this.resultImg = res;
            // //////console.log(this.resultImg);
            this.info.uid = +sessionStorage.getItem("token");
            (this.info.agreement = ""),
              (this.info.autograph = this.resultImg),
              ////console.log(this.info);
              axios
                .post(`/agreement/agreement/updateAutograph`, this.info)
                .then(res => {
                  if (res) {
                    //code
                    ///
                    //"\r\n### Error updating database.  Cause: com.mysql.cj.jdbc.exceptions.MysqlDataTruncation: Data truncation: Data too long for column 'autograph' at row 33\r\n### The error may exist in file [D:\\lf\\p2p\\p2p-loan\\target\\classes\\mapper\\loan\\PAgreementMapper.xml]\r\n### The error may involve defaultParameterMap\r\n### The error occurred while setting parameters\r\n### SQL: update p_agreement set autograph=? where uid=?\r\n### Cause: com.mysql.cj.jdbc.exceptions.MysqlDataTruncation: Data truncation: Data too long for column 'autograph' at row 33\n; Data truncation: Data too long for column 'autograph' at row 33; nested exception is com.mysql.cj.jdbc.exceptions.MysqlDataTruncation: Data truncation: Data too long for column 'autograph' at row 33"

                    ////console.log(res.data.code);

                    if (res.data.code == 500) {
                      this.$message.error("Signature amplitude too large");
                      return
                    }
                    this.$message.success("Signature completed");
                    this.$router.push("/MyProfileviews");
                  }
                }).catch;
          })
          .catch(err => {
            this.$message.error("Not Signned");
          });
      } else {
        this.$message({
          type: "error",
          message: "User information already exists, please contact the administrator to modify it"
        });
        this.$router.push("/MyProfileviews");
      }
    }
  }
};
</script>

<style scoped>
.aaa {
  width: 100%;
}
::v-deep .esign {
  width: 100%;
}
.esignTest {
  width: 100%;
}
.imgs {
  width: 100%;
}
.imgs img {
  width: 80%;
  object-fit: contain;
}
.design-set {
  margin-top: 80px;
  width: 100%;
  border: 1px solid #093a97;
  display: flex;
  justify-content: center;
}
.foot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}

.information-bottom {
  left: 0;
  bottom: 0;
  position: absolute;
  width: 40%;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 25px;
  background-color: #a95159;
  cursor: pointer;
}
.information-bottom1 {
  right: 0;
  bottom: 0;
  position: absolute;
  width: 40%;
  color: #fff;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 25px;
  background-color: #a95159;
  cursor: pointer;
}
.changecolor{
    background-color: #C0C4CC;
}
</style>
